@if (!submitted() && data() && sortedInputs().length) {
  <div class="tw-w-full">
    @if (imageInputs().length) {
      <div class="tw-flex tw-flex-wrap tw-gap-1 tw-px-2">
        @for (each of imageInputs(); track each.originalIndex) {
          <div [id]="'imgInp' + each.originalIndex"
               class="tw-w-full tw-max-w-[100px] tw-aspect-square"
               rippleEffect="rippleEffect"
               rippleClass="ripple-blue"
               (click)="selectedIndex.set(each.originalIndex)"
               (callback)="sendMessage()">
            <img [src]="each.params.imageUrl" alt="User" class="tw-w-full tw-h-full tw-object-cover tw-object-top" />
          </div>
        }
      </div>
    }
    @for (each of buttonInputs(); track each.originalIndex) {
      <span
        type="button"
        [id]="'buttonInput' + each.originalIndex"
        class="tw-w-full tw-flex tw-justify-center tw-items-center tw-border-t tw-border-teal-300 tw-py-2 tw-text-center tw-font-semibold tw-font-lexend tw-text-teal-600"
        [class.tw-pointer-events-none]="isEffectivelyClosed()"
        (click)="selectedIndex.set(each.originalIndex); sendMessage()">
        {{ each.text }}
      </span>
    }
  </div>
}
